<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window invite-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper dialog-content">
                <div class="dialog-body">
                    <div class="dialog-title t-invite">好友绑定</div>
                    <div class="invite-view">
                        <div class="share-text msg-view">
                            <div class="text-content">
                            可邀请今年（2025年1月1日-2025年6月11日）未进行过消费的好友进行绑定，绑定后该好友在本次活动中进行消费时，您也会以其消费额5：1的比例获得狂欢积分。
                            </div>
                        </div>

                        <div class="u-btn invite" @click="call_copy()"></div>
                    </div>

                    <div class="friend-data">
                        <div class="table-data">
                            <div class="table-head flex-between-center">
                                <div class="table-tr" style="width: 120px;">名称</div>
                                <div class="table-tr" style="width: 100px;">大区</div>
                                <div class="table-tr" style="width: 120px;">消费额</div>
                                <div class="table-tr" style="width: 120px;">转化的积分</div>
                            </div>                        

                            <div class="table-body">
                                <vuescroll>
                                    <div class="table-item flex-between-center" v-for="(item,index) in list" :key="index">
                                        <div class="table-tr text-overflow-1" style="width: 120px;">{{ item.nickName }}</div>
                                        <div class="table-tr" style="width: 100px;">{{ $global.queryArea(item.zid) }}</div>
                                        <div class="table-tr" style="width: 120px;">{{ item.score * 5 }}<em class="icon-m3b"></em></div>
                                        <div class="table-tr text-overflow-1" style="width: 120px;">{{ item.score }}<em class="icon-token"></em></div>
                                    </div>                                  
                                </vuescroll>
                            </div>
                           
                        </div>
                    </div>

                </div>

            </div>         
        </div>
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
import {
    apiInviteList,
    apiInviteCode,   
} from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            error_text : '请稍后再试', 
            error : false,
            shareTxt : '', 
            list : [],                 
        }
    },
    created (){   
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.init();
    },
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        init (){
            apiInviteList().then(
                res => {
                    this.list = res.data;
                }
            )            
        },
        call_copy(){
            
            apiInviteCode({mode : 1}).then(
                res => {
                    this.destroyElement();
                    let shareTxt = res.data.koudai  ? (res.data.koudai + res.data.url) : res.data.url; 
                    this.$copy_modal({ shareTxt : shareTxt });                  
                },
                rej => {
                    this.$toast(rej.message)
                }
            )
        },        
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              _this.$toast("复制成功");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },             
    },
}
</script>

<style lang="scss" scoped>
.dialog-view .dialog-content{
    padding: 20px 0 25px 0;
}

.invite-view{
    padding: 10px 20px 0;
}

.text-content{
    font-size: 22px;
    color: #666565;
    line-height: 1.4;

    p{
        margin: 0;
    }
}


.notice{
    margin-top: 20px;
    font-size: 18px;
    color: #ee6044;
    text-align: center;
}

.table-data{
    text-align: center;
}

.table-item{
    width: 100%;
    padding: 0 20px;
    margin-bottom: 5px;
    box-sizing: border-box;
}

.table-tr{
    text-align: center;
}

.table-head{
    width: 100%;
    padding: 58px 20px 0;
    font-size: 20px;
    color: #e8533d;
    background-image: url(~@/assets/images/modal/table-head.png);
    background-repeat: no-repeat;
    background-position: top center;
}

.table-body{
    height: 250px;
    font-size: 20px;
    color: #b4a58d;
}

.info{
    font-size: 20px;
    text-align: center;
    margin-bottom: 18px;
}

.u-btn.invite{
    width: 190px;
    height: 54px;
    margin: 5px auto 10px;
    background-image: url(~@/assets/images/modal/btn-invite.png);
} 

</style>